module.exports = __webpack_public_path__ + "static/media/skills.e17c799d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/skills.png
// module id = 1077
// module chunks = 0